import React from "react";
import PageWrapper from "../../../components/PageWrapper/PageWrapper";
import HeroSection from "../../../components/HeroSection/HeroSection";
import HeroCaption from "../../../components/HeroCaption/HeroCaption";

import FacultyResponsive from "../../../components/FacultyResponsive/FacultyResponsive";
import CoursesResponsive from "../../../components/CoursesResponsive/CoursesResponsive";
import DepartmentInfoResponsive from "../../../components/DepartmentInfoResponsive/DepartmentInfoResponsive";
import DepartmentAboutInfoResponsive from "../../../components/DepartmentAboutInfoResponsive/DepartmentAboutInfoResponsive";
import HODResponsive from "../../../components/HODResponsive/HODResponsive";

import { mechanicalLessonPlan } from "../../../static-data/courselessonplan.data";
import { mechanicalMaterials } from "../../../static-data/coursematerial.data";
import ResourcesResponsive from "../../../components/ResourcesResponsive/ResourcesResponsive";

const hodData = {
  imageUrl: require("../../../assets/hod-images/mech.png"),
  designation: "Head of the Department",
  name: "PROF. PINAK BHUSAN DASH",
  feedback: `I heartly welcome you to the department of mechanical engg. It is a matter of pride & pleasure for me to introduce our department. We are living in a technological age & technology is at the heart of what we do in MECHANICAL ENGG. We design, develop & advance modern technologies to improve our world & our quality of life.

MECHANICAL ENGG. department is a community of students, faculty & staff dedicated to educating the next generation of mechanical  engineers & to conduct research on the next generation of technology. MECHANICAL ENGG. department  offers incredible flexibility, enabling you to customize your plan of study. Department community give our students the opportunity for invaluable experimental learning, which in turn gives our graduates an incredible viewof the job market.

Our faculty perform impactful research on state-of-the-art technologies. We publish in top-tier journals & conferences.

Please look around our website for more information & don’t hesitate to contact us for more information.
    `,
};

const mechanicalSyllabus =
  "https://drive.google.com/drive/folders/1zx0kwp6RwkaRfXfExGVTWO7iOAGN-NTi?usp=drive_link";

const MechanicalPage = () => {
  return (
    <PageWrapper className="mt-n6">
      <HeroSection className="bg-page-background-7">
        <HeroCaption
          title="Mechanical Engineering"
          position="bottom-left"
          breadcrumb={true}
          breadcrumbPrefix="Home"
        />
      </HeroSection>
      <DepartmentInfoResponsive
        title={"Mechanical"}
        desc={`The Mechanical Engineering Department at NIET offers a comprehensive education in the field of mechanical engineering. Our department is dedicated to providing students with the skills and knowledge they need to succeed in the industry and make valuable contributions to society.

`}
      />
      <HODResponsive hodData={hodData} />
      <DepartmentAboutInfoResponsive
        title={"About department"}
        desc={`The Mechanical Engineering Department at NIET offers a comprehensive education in the field of mechanical engineering. Our department is dedicated to providing students with the skills and knowledge they need to succeed in the industry and make valuable contributions to society.
				Our faculty members are experts in their respective fields and are committed to delivering a challenging and rigorous curriculum that covers a wide range of topics, including mechanics, thermodynamics, manufacturing, design, and robotics. We offer a B.Tech in Mechanical Engineering program that covers both core and elective courses, allowing students to specialize in their area of interest.
				Our department is equipped with state-of-the-art facilities, including mechanical labs, simulation tools, and equipment, to support students' practical learning experience. We also provide opportunities for students to work on projects and participate in research programs to gain hands-on experience.
				We encourage students to participate in co-curricular activities such as technical paper presentations, project exhibitions, and industry collaborations, which provide them with opportunities to showcase their skills and talents and network with industry professionals.
				Our goal at NIET's Mechanical Engineering Department is to produce graduates who are well-prepared to contribute to the industry and society as a whole. We are committed to providing our students with the best possible education in mechanical engineering and equipping them with the skills they need to succeed in their chosen career paths.`}
        href={process.env.PUBLIC_URL + "/MECH BPUT PROFILE DATA 2026.xlsx"}
        docLinkText={"MECH Department Information"}
      />
      <ResourcesResponsive
        syllabusLink={mechanicalSyllabus}
        courseLessonPlan={mechanicalLessonPlan}
        courseMaterial={mechanicalMaterials}
      />
    </PageWrapper>
  );
};

export default MechanicalPage;
